export default __webpack_public_path__ + "static/media/ServiceShare.6d27ad19.svg";